var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadRoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327 202",
    width: 200,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "road-roller") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #f6911d } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m315.8 94.8l-30.3-8.5v-22.7l6.6-5.7-3.2-3.8-8.4 7.3v23.5l-11.7-3.3v-17.5h-3.6v16.5l-21.5-6.1v-43.5h7.3v-11h-16.5v-10h-69v10h-21.5v11h10.3l-15.9 68h-12.4v11.5h-8.5v13.3 4h-117.5v33h123.5 2.8v12.2h60.2c-2.1-5.2-3.2-10.9-3.2-16.8 0-25.4 20.5-45.9 45.9-45.9 25.3 0 45.8 20.5 45.8 45.9 0 5.9-1.1 11.6-3.2 16.8h35.9v-12.2h14l-0.6-6.8h5.9v-12h-7zm-37.8 8.3h28v4h-28zm0 8.9h28v4h-28zm0 9.1h28v4h-28zm-108.4-22.1l-2-9.1q1 0 1.9 0c7.5 0 13.7-2.5 18.2-5q0 0 0 0.1c0.7 4 1.7 8.9 2.2 14.1zm63.7-14.7h-23.3v-53.4h23.3zm-70.8-53.3h42.3v48.5c-2.8-5.7-8.2-7.6-12.1-6.7-1.4 0.3-2.6 1.1-3.5 2.3-2.5 2.3-11.3 9-23.2 7.6l-0.1-0.7c0.7-0.6 1.2-1.5 1.2-2.5 0-1.8-1.4-3.2-3.2-3.2-1.8 0-3.2 1.4-3.2 3.2 0 1.6 1.1 2.8 2.5 3.2l0.1 0.3c-0.9 0.5-1.6 1.5-1.7 2.6-0.3 1.9 1 3.7 2.9 3.9q0.1 0.1 0.2 0.1l2.1 9.4h-20.2zm-94.9 120c-3.9 0-7-3.1-7-7 0-3.8 3.1-7 7-7 3.8 0 7 3.2 7 7 0 3.9-3.2 7-7 7zm98.6 11.7h-28v-4h28zm0-9h-28v-4h28zm-28-9v-4h28v4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m67 194.3c20.3-0.1 37.8-12.2 45.6-29.6h-91.2c7.8 17.4 25.3 29.5 45.6 29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m67 94.3c-20.3 0-37.8 12.1-45.6 29.5h91.2c-7.8-17.4-25.3-29.5-45.6-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m266.8 156.2c0-20.8-16.9-37.7-37.6-37.7-20.8 0-37.7 16.9-37.7 37.7 0 20.7 16.9 37.6 37.7 37.6 20.7 0 37.6-16.9 37.6-37.6zm-37.6 21.3c-11.8 0-21.3-9.6-21.3-21.3 0-11.8 9.5-21.3 21.3-21.3 11.7 0 21.3 9.5 21.3 21.3 0 11.7-9.6 21.3-21.3 21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m196.3 60.4c-0.2 6.3-5.4 11.4-11.8 11.3-6.3-0.2-11.4-5.4-11.2-11.8 0.1-6.3 5.3-11.4 11.7-11.3 6.4 0.2 11.4 5.4 11.3 11.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadRoller);
export default __webpack_public_path__ + "static/media/road-roller.5ef44e18570757539aba2605191402d1.svg";
export { ForwardRef as ReactComponent };